/*
 * ____   ____    .__   __
 * \   \ /   /___ |  |_/  |______      ____ ___.__.
 *  \   Y   /  _ \|  |\   __  \_ \   / ___<   |  |
 *   \     (  <_> )  |_|  |  / __ \_/ /_/  >___  |
 *    \___/ \____/|____/__| (____  /\___  // ____|
 *                               \//_____/ \/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

import React from "react";
import { useTranslation } from "react-i18next";

const ErrorScreen = ({ error, darkMode }) => {
  const { t } = useTranslation("base"); // No customer specifc configuration allowed here

  return (
    <div
      className={`flex items-center justify-center h-screen ${
        darkMode ? "bg-gray-900" : "bg-red-50"
      }`}
    >
      <div className="text-center">
        <div className="text-red-600 text-5xl mb-4">⚠️</div>
        <h1
          className={`text-2xl font-bold mb-2 ${
            darkMode ? "text-red-300" : "text-red-800"
          }`}
        >
          {t("errorScreen.title")}
        </h1>
        <p className={`mb-4 ${darkMode ? "text-red-200" : "text-red-700"}`}>
          {error.message || t("errorScreen.defaultErrorMessage")}
        </p>
        <div className="space-y-4">
          <button
            className={`px-4 py-2 ml-2 rounded transition-colors ${
              darkMode
                ? "bg-red-700 text-white hover:bg-red-600"
                : "bg-red-600 text-white hover:bg-red-700"
            }`}
            onClick={() => window.location.reload()}
          >
            {t("errorScreen.reloadButton")}
          </button>
        </div>
        <div className={`mt-8 ${darkMode ? "text-gray-300" : "text-gray-700"}`}>
          <p>{t("errorScreen.helpText")}</p>
          <ul className="list-disc list-inside mt-2">
            <li>
              <a
                className="underline hover:text-blue-500"
                href="https://support.voltagy.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                {t("errorScreen.supportPortalLink")}
              </a>
            </li>
            <li>
              <a
                className="underline hover:text-blue-500"
                href="mailto:support@voltagy.com"
              >
                {t("errorScreen.supportEmailLink")}
              </a>
            </li>
            <li>{t("errorScreen.supportHotline")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorScreen;
